module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shelves-right-wrap"
  }, [_c('div', {
    staticClass: "operation",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('el-row', [(_vm.dislayFlag) ? _c('div', {
    staticStyle: {
      "font-size": "14px",
      "margin-top": "6px",
      "color": "#494949"
    }
  }, [_vm._v("\n        采购车导入的待支付订单有\n        "), _c('span', {
    staticStyle: {
      "color": "#f7ba2a",
      "font-weight": "600"
    }
  }, [_vm._v(_vm._s(_vm.totalDetailNum))]), _vm._v("个商品，形成\n        "), _c('span', {
    staticStyle: {
      "color": "#f7ba2a",
      "font-weight": "600"
    }
  }, [_vm._v(_vm._s(_vm.totalInfoNum))]), _vm._v("个订单\n      ")]) : _vm._e()]), _vm._v(" "), _c('el-row', [(_vm.dislayFlag) ? _c('div', {
    staticStyle: {
      "font-size": "14px",
      "color": "#494949"
    }
  }, [_vm._v("\n        订单已占用库存，随创建时间\n        "), _c('span', {
    staticStyle: {
      "color": "#f7ba2a"
    }
  }, [_vm._v("30")]), _vm._v("分钟内未付款，会自动取消订单\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "batch-operation ineffective-operation",
    staticStyle: {
      "float": "right",
      "top": "5px"
    },
    on: {
      "click": _vm.removeData
    }
  }, [_vm._v("批量取消订单")])], 1), _vm._v(" "), _c('div', {
    staticClass: "shopCar_table"
  }, [(_vm.orderList.length != 0) ? _c('table', {
    staticClass: "shelves-table",
    staticStyle: {
      "width": "1040px"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-header-selectall th-blank-block",
    class: {
      'yigouxuan': _vm.isAllSelect
    },
    staticStyle: {
      "padding-left": "0"
    },
    on: {
      "click": _vm.allSelect
    }
  }, [_vm._v("商品信息")]), _vm._v(" "), _c('th', [_vm._v("结算单价")]), _vm._v(" "), _c('th', [_vm._v("数量")]), _vm._v(" "), _c('th', [_vm._v("总额")]), _vm._v(" "), _c('th', [_vm._v("运费")]), _vm._v(" "), _c('th', [_vm._v("自有订单号")])])]), _vm._v(" "), _vm._l((_vm.orderList), function(item, index) {
    return _c('tbody', {
      key: index,
      staticClass: "order-tbody"
    }, [_vm._m(0, true), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "shelves-table-block-title blank-block",
      class: {
        'yigouxuan': item.isSelect
      },
      attrs: {
        "colspan": "12"
      },
      on: {
        "click": function($event) {
          return _vm.selectItem(index)
        }
      }
    }, [_c('span', [_vm._v("订单编号：" + _vm._s(item.orderSn))]), _vm._v(" "), _c('span', [_vm._v("收件人：" + _vm._s(item.linkMan))]), _vm._v(" "), _c('span', [_vm._v("收货人电话：" + _vm._s(item.mobile))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.address1))])])]), _vm._v(" "), _vm._l((item.orderDetailList), function(detail, index) {
      return _c('tr', {
        key: index,
        staticClass: "order-table-item"
      }, [_c('td', {
        staticClass: "order-table-image"
      }, [_c('div', {
        staticClass: "order-table-image-wrap"
      }, [_c('img', {
        attrs: {
          "src": detail.imagePath
        },
        on: {
          "error": function($event) {
            return _vm.error(1)
          }
        }
      })]), _vm._v(" "), _c('div', [_c('div', {
        staticClass: "order-goods-name"
      }, [_vm._v(_vm._s(detail.goodsName))]), _vm._v(" "), _c('div', {
        staticClass: "order-default-font order-guige",
        staticStyle: {
          "color": "#A2A2A2"
        }
      }, [_vm._v(_vm._s(detail.specName))]), _vm._v(" "), _c('div', {
        staticClass: "order-default-font order-guige",
        staticStyle: {
          "color": "#A2A2A2"
        }
      }, [_vm._v("SKU号：" + _vm._s(detail.productId))]), _vm._v(" "), (detail.isOwns > 0) ? _c('div', {
        staticStyle: {
          "border": "1px solid rgb(103,191,135)",
          "width": "60px",
          "text-align": "center",
          "color": "rgb(64,173,104)",
          "background-color": "rgb(240,255,246)",
          "font-size": "12px",
          "display": "block"
        }
      }, [_vm._v("自产自销")]) : _vm._e()])]), _vm._v(" "), _c('td', {
        staticClass: "order-default-font"
      }, [_vm._v("¥" + _vm._s(detail.cooperatePrice / 100))]), _vm._v(" "), _c('td', {
        staticClass: "order-default-font"
      }, [_vm._v(_vm._s(detail.quantity))]), _vm._v(" "), (index == 0) ? _c('td', {
        staticClass: "order-toDetail",
        attrs: {
          "rowspan": item.orderDetailList.length
        }
      }, [_c('span', {
        staticStyle: {
          "display": "block",
          "color": "#ffa726"
        }
      }, [_vm._v(_vm._s(item.totalCooperatePrice / 100))])]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("￥" + _vm._s(item.freight / 100))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(detail.ownerOrderSn))])])
    })], 2)
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.orderList.length != 0) ? _c('div', {
    staticClass: "certainButton",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('span', {
    staticClass: "spanClass"
  }, [_vm._v("\n      货款:\n      "), _c('span', {
    staticStyle: {
      "color": "#494949"
    }
  }, [_vm._v("￥" + _vm._s(_vm.totalInfo.totalCooperatePrice / 100))])]), _vm._v(" "), _c('span', {
    staticClass: "spanClass"
  }, [_vm._v("\n      总运费:\n      "), _c('span', {
    staticStyle: {
      "color": "#494949"
    }
  }, [_vm._v("￥" + _vm._s(_vm.totalInfo.totalFreight / 100))])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-right": "8px",
      "margin-top": "13px",
      "display": "inline-block"
    }
  }, [_vm._v("\n      总计:\n      "), _c('span', {
    staticClass: "priceColor",
    staticStyle: {
      "color": "#494949"
    }
  }, [_vm._v("￥" + _vm._s(_vm.totalInfo.total / 100))])]), _vm._v(" "), _c('span', {
    staticClass: "spanClass"
  }, [_vm._v("\n      可用余额:\n      "), _c('span', {
    staticStyle: {
      "color": "#494949"
    }
  }, [_vm._v("￥" + _vm._s(_vm.totalInfo.lastMoney / 100))])]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "170px",
      "height": "50px",
      "border-radius": "0",
      "font-size": "16px"
    },
    attrs: {
      "type": "warning",
      "size": "small",
      "disabled": _vm.disalbedFlag
    },
    on: {
      "click": _vm.centainOrder
    }
  }, [_vm._v("确认订单")]), _vm._v(" "), (_vm.disalbedFlag) ? _c('div', {
    staticClass: "reminder export-tips"
  }, [_c('span', [_vm._v("可用余额不足")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [(_vm.orderList.length != 0) ? _c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageNum,
      "total": _vm.total,
      "page-size": 10
    },
    on: {
      "current-change": _vm.handlebinCurrentChange,
      "update:currentPage": function($event) {
        _vm.pageNum = $event
      },
      "update:current-page": function($event) {
        _vm.pageNum = $event
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "self-tbody-space",
    attrs: {
      "colspan": "7"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5329d629","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/shopCarGoOrder.vue
// module id = 533
// module chunks = 1